<div class="mat-elevation-z8">
  <table mat-table class="stripped-table" #taxCreditTable
         #dataSort="matSort" [dataSource]="dataSource" matSort>

    <!-- Name Column -->
    <ng-container matColumnDef="field">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Info </th>
      <td mat-cell class="name-column" *matCellDef="let row"> {{row.field}} </td>
    </ng-container>

    <!-- Value Column -->
    <ng-container matColumnDef="value">
      <th mat-header-cell *matHeaderCellDef> Value </th>
      <td mat-cell *matCellDef="let row">{{row.value}}</td>
    </ng-container>

<!--    <tr mat-header-row *matHeaderRowDef="dataColumns"></tr>-->
    <tr mat-row *matRowDef="let row; columns: dataColumns;"></tr>
  </table>
</div>
